import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  loaderWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.dark.darkSlateBlue,
  },
  loader: {
    width: 50,
    height: 50,
    margin: '20px 0',
  },
}));

export const useStylesCircularProgress = makeStyles(theme => ({
  root: {
    width: '50px !important',
    height: '50px !important',
  },
  colorPrimary: {
    color: theme.colors.light.ghostWhite,
  },
}));
